
import React from 'react';
import { Button } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";
import { Link, useParams } from "react-router-dom"
import { toast } from "react-toastify";

import { useVehicleMaintenanceDetailContext, VehicleMaintenanceDetailContext } from "contexts/VehicleMaintenanceDetailContext";
import { useGetVehicleMaintenanceDetailQuery, useUpdateVehicleMaintenanceMutation } from "store/services/vehicleMaintenanceApi";

import VehicleMaintenanceBasicDetail from "./VehicleMaintenanceComponents/VehicleMaintenanceBasicDetail";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import EnableDisableButton from "components/Shared/EnableDisableButton";
import { useAuth } from "hooks";


const VehicleMaintenanceDetailScreen = () => {

  const { id } = useParams();

  const breadcrumb = [
    { title: "Vehicle Maintenance", path: "/app/crm/vehicle-maintenance/list" },
    { title: "Vehicle Maintenance Detail" }
  ]

  // RTK Query
  const {
    data: vehicleMaintenanceDetail,
    isLoading: loadingVehicleMaintenance,
    error,
  } = useGetVehicleMaintenanceDetailQuery(id);

  return (
    <VehicleMaintenanceDetailContext.Provider value={{ vehicleMaintenanceDetail, loadingVehicleMaintenance }} >
      <BreadcrumbLayout breadcrumbs={breadcrumb}
        isBusy={loadingVehicleMaintenance}
        headerActions={<PageActions />} >
        <BreadcrumbLayout.Error error={error} />

        <BreadcrumbLayout.Paper>
          <VehicleMaintenanceBasicDetail />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </VehicleMaintenanceDetailContext.Provider>
  )
}

export default VehicleMaintenanceDetailScreen;

const PageActions = () => {

  const { isAccountAdmin } = useAuth();
  
  const { vehicleMaintenanceDetail, loadingVehicleMaintenance } = useVehicleMaintenanceDetailContext();

  // RTK Query
  const [updateVehicleMaintenance, { isLoading: updatingVehicleMaintenance }] = useUpdateVehicleMaintenanceMutation();

  // methods
  const handelToggleMaintenanceStatus = async () => {
    try {
      await updateVehicleMaintenance({
        _id: vehicleMaintenanceDetail._id,
        isActive: !vehicleMaintenanceDetail.isActive,
      }).unwrap();
      toast.info(`maintenance ${vehicleMaintenanceDetail.isActive ? "Disable" : "Enable"} !`);
    } catch (error) {
      toast.error(error?.data.message ?? "Could Not Update Status");
    }
  }

  return (
    <div className="flex space-x-4">
      {isAccountAdmin &&( <EnableDisableButton
        isActive={vehicleMaintenanceDetail?.isActive}
        loading={loadingVehicleMaintenance || updatingVehicleMaintenance}
        onClick={handelToggleMaintenanceStatus}
      />)}
      <Link to={`/app/crm/vehicle-maintenance/${vehicleMaintenanceDetail?._id}/edit`}>
        <Button startIcon={<EditOutlined />} variant="contained">
          Edit
        </Button>
      </Link>
    </div>
  );
};
